<template>
  <div class="home">
    <Header title="门店服务" />
    <!-- 菜单 -->
    <van-grid>
      <van-grid-item
        :icon="require('@/assets/activity_apply.png')"
        text="活动申请"
        to="/activity/apply"
      />
      <van-grid-item
        :icon="require('@/assets/activity_list.png')"
        text="活动列表"
        to="/activity/list"
      />
      <van-grid-item
        :icon="require('@/assets/activity_detail.png')"
        text="活动详情"
        to="/order/purchaseInfo"
      />
      <van-grid-item
        :icon="require('@/assets/combo.png')"
        text="会员套餐"
        to="/combo/membersPackageList"
      />
      <van-grid-item
        :icon="require('@/assets/combo_list.png')"
        text="套餐详情"
        to="/combo/comboList"
      />
      <van-grid-item
        :icon="require('@/assets/active_icon.png')"
        text="卡券激活"
        to="/order/activate"
      />
      <van-grid-item
        :icon="require('@/assets/verification.png')"
        text="核销"
        @click="verificationShow = true"
      />
      <!-- <van-grid-item
        :icon="require('@/assets/appointment_management.png')"
        text="预约管理"
        to="/appointment/detail"
      /> -->
      <!-- <van-grid-item
        :icon="require('@/assets/salesclerk.png')"
        text="员工管理"
        to="/clerk/salesclerkList"
      /> -->
      <!-- <van-grid-item
        :icon="require('@/assets/inspection.png')"
        text="逢车必检"
        to="/inspection/inspectionFirst"
      /> -->
      <!-- <van-grid-item
        :icon="require('@/assets/oil_pointer.png')"
        text="出厂油标查询"
        url="https://embed.sopei.cn/#/b751af04a339944b"
      /> -->
      <!-- <van-grid-item
        :icon="require('@/assets/account-setting.png')"
        text="账户设置"
        to="/user/accountSetting"
      /> -->
    </van-grid>
    <!-- 核销弹框 -->
    <div class="verification-popup">
      <van-popup v-model="verificationShow">
        <div class="title">核销</div>
        <div class="card-info">
          <van-cell-group>
            <van-field
              v-model="couponCode"
              label="券码"
              placeholder="请输入券码"
              right-icon="scan"
              @click-right-icon="handleScan"
            />
          </van-cell-group>
        </div>
        <div class="activate-btn">
          <van-row type="flex" justify="space-around">
            <van-col>
              <van-button type="default" @click="handleCancel">
                取消
              </van-button>
            </van-col>
            <van-col>
              <van-button type="primary" @click="handleVerification">
                核销
              </van-button>
            </van-col>
          </van-row>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import { Dialog } from "vant";
import wx from "weixin-js-sdk";
import { writeOff } from "@/api/order";
import { weiXingSDK } from "@/api/user";

export default {
  name: "Home",
  beforeRouteEnter(to, from, next) {
    if (from.path === "/") {
      weiXingSDK(encodeURIComponent(location.href)).then((res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ["scanQRCode"],
        });
      });
    }
    next();
  },
  components: {
    Header,
  },
  data() {
    return {
      verificationShow: false,
      couponCode: "",
    };
  },
  mounted() {
    // 门店若无定位,前往设置
    // let dealerLatitude = JSON.parse(
    //   sessionStorage.getItem("userInfo")
    // ).dealerLatitude;
    // let telephone = JSON.parse(
    //   sessionStorage.getItem("userInfo")
    // ).dealerTelephone;
    // if (!dealerLatitude) {
    //   Dialog.confirm({
    //     title: "温馨提示",
    //     message: "请先在账户设置中将门店电话或门店地址填写完整",
    //   })
    //     .then(() => {
    //       this.$router.push("/user/accountSetting");
    //     })
    //     .catch(() => {});
    // } else if (!telephone) {
    //   Dialog.confirm({
    //     title: "温馨提示",
    //     message: "请先在账户设置中将门店电话或门店地址填写完整",
    //   })
    //     .then(() => {
    //       this.$router.push("/user/accountSetting");
    //     })
    //     .catch(() => {});
    // }
  },
  methods: {
    // 扫码
    handleScan() {
      let that = this;
      wx.checkJsApi({
        jsApiList: ["scanQRCode"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function () {
          wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode"],
            success: function (res) {
              that.couponCode = res.resultStr;
            },
          });
        },
        fail: function () {
          Dialog.confirm({
            title: "温馨提示",
            message: "当前微信版本不支持扫码,请升级微信后尝试",
          });
        },
      });
    },
    // 核销
    handleVerification() {
      if (this.couponCode.trim() === "") {
        this.$toast("请输入券码");
        return;
      }
      Dialog.confirm({
        title: "温馨提示",
        message: "确定核销该优惠券?",
      })
        .then(() => {
          writeOff(this.couponCode).then((result) => {
            // console.log("核销:", result);
            if (result.code === 0) {
              Dialog.alert({
                title: "温馨提示",
                message: "核销成功",
              });
            }
          });
          this.couponCode = "";
        })
        .catch(() => {});
    },
    // 取消
    handleCancel() {
      this.verificationShow = false;
      this.couponCode = "";
      this.activityColumns = [];
      this.handleDefaultDate();
    }
  },
};
</script>
<style lang="scss" scoped>
.home {
  .activate-popup {
    .title {
      height: 40px;
      background-color: #007aff;
      line-height: 40px;
      color: #fff;
    }
  }

  .verification-popup {
    .title {
      height: 40px;
      background-color: #007aff;
      line-height: 40px;
      color: #fff;
    }
  }

  .card-info {
    margin-bottom: 20px;
  }

  .activate-btn {
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
.home {
  .van-grid-item__content::after {
    display: none;
  }

  .van-icon__image {
    width: 1.5em;
    height: 1.5em;
  }

  .activate-popup {
    .van-popup {
      width: 80%;

      .card-info {
        .van-field__label {
          text-align: left;
        }
      }
    }
  }

  .verification-popup {
    .van-popup {
      width: 80%;

      .card-info {
        .van-field__label {
          text-align: left;
        }
      }
    }
  }

  .activate-btn {
    .van-button {
      width: 90px;
    }
  }
}
</style>
